export const SET_AUTH = 'SET_AUTH'
export const PURGE_AUTH = 'PURGE_AUTH'
export const SET_ERROR = 'SET_ERROR'
export const AUTH_SUCESS = 'AUTH_SUCESS'
export const SET_ORDERLIST = 'SET_ORDERLIST'
export const SET_VENDORLIST = 'SET_VENDORLIST'
export const SET_NOTELIST = 'SET_NOTELIST'
